module.exports = __webpack_public_path__ + "static/media/sampleForm.70014a9e.docx";


//////////////////
// WEBPACK FOOTER
// ./src/components/school/sampleForm.docx
// module id = 776
// module chunks = 81